<template>
<v-layout fluid fill-height>
    <v-flex row wrap>
        <v-card min-height="100px" min-width="100px" height="100%">
            <v-layout row wrap>

                <v-progress-linear :indeterminate="true" :active="!WeatherData" v-if="!WeatherData"></v-progress-linear>

                <v-flex v-if="WeatherData" class="grey lighten-4">

                    <h1 class="ma-3">Weather</h1>

                    <v-card class="elevation-5 ma-3" v-for="plantWeather in WeatherData" v-bind:key="plantWeather.PlantID">
                        <v-card-title>
                            <h2>{{plantWeather.PlantName}}</h2>
                        </v-card-title>
                        <v-card-text>

                            <v-layout wrap>

                                <v-flex xl2 lg2 md4 sm6 xs12>
                                    <h3 class="mb-3">Current</h3>
                                    <v-card>

                                        <v-layout>
                                            <v-flex xs8>
                                                <v-card-title class="subheading">{{ plantWeather.CurrentWeather.ObservedDateTime | formatDateTime }}</v-card-title>
                                            </v-flex>
                                            <v-flex xs4 class="text-xs-right" mr-2 mt-1>
                                                <weatherIcon :WeatherIconName="plantWeather.CurrentWeather.Icon" :width="64" :height="64"></weatherIcon>
                                            </v-flex>
                                        </v-layout>

                                        <v-divider></v-divider>

                                        <v-list dense>
                                            <v-list-tile>
                                                <v-list-tile-content style="max-width:180px; height:auto;">{{ plantWeather.CurrentWeather.Summary }}</v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile>
                                                <v-list-tile-content>Temperature:</v-list-tile-content>
                                                <v-list-tile-content class="align-end">{{ plantWeather.CurrentWeather.Temperature | formatNumberTo2Decimals }} &#8451;</v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile>
                                                <v-list-tile-content>Apparent Temperature:</v-list-tile-content>
                                                <v-list-tile-content class="align-end">{{ plantWeather.CurrentWeather.ApparentTemperature | formatNumberTo2Decimals }} &#8451;</v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile>
                                                <v-list-tile-content>Precip Probability:</v-list-tile-content>
                                                <v-list-tile-content class="align-end">{{ plantWeather.CurrentWeather.PrecipProbability | formatDecimalToPercentage }}</v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile>
                                                <v-list-tile-content>Precip Intensity:</v-list-tile-content>
                                                <v-list-tile-content class="align-end">{{ plantWeather.CurrentWeather.PrecipIntensityMmph | formatNumberTo2Decimals }} mm/h</v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile>
                                                <v-list-tile-content>Humidity:</v-list-tile-content>
                                                <v-list-tile-content class="align-end">{{ plantWeather.CurrentWeather.Humidity | formatDecimalToPercentage }}</v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile>
                                                <v-list-tile-content>Pressure:</v-list-tile-content>
                                                <v-list-tile-content class="align-end">{{ plantWeather.CurrentWeather.PressureHectopascals | formatNumberTo2Decimals }}</v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile>
                                                <v-list-tile-content>Dew Point:</v-list-tile-content>
                                                <v-list-tile-content class="align-end">{{ plantWeather.CurrentWeather.DewPoint | formatNumberTo2Decimals }}</v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile>
                                                <v-list-tile-content>Wind Speed:</v-list-tile-content>
                                                <v-list-tile-content class="align-end">{{ plantWeather.CurrentWeather.WindSpeedKmph | formatNumberTo2Decimals }} Km/h</v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile>
                                                <v-list-tile-content>Wind Gust:</v-list-tile-content>
                                                <v-list-tile-content class="align-end">{{ plantWeather.CurrentWeather.WindGustKmph | formatNumberTo2Decimals }} Km/h</v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile>
                                                <v-list-tile-content>Wind Bearing:</v-list-tile-content>
                                                <v-list-tile-content class="align-end">{{ plantWeather.CurrentWeather.WindBearingDegrees | formatNumberTo2Decimals }} &#176;</v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile>
                                                <v-list-tile-content>Cloud Cover:</v-list-tile-content>
                                                <v-list-tile-content class="align-end">{{ plantWeather.CurrentWeather.CloudCover | formatDecimalToPercentage }}</v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile>
                                                <v-list-tile-content>UV Index:</v-list-tile-content>
                                                <v-list-tile-content class="align-end">{{ plantWeather.CurrentWeather.UVIndex | formatNumberTo2Decimals }}</v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile>
                                                <v-list-tile-content>Visibility:</v-list-tile-content>
                                                <v-list-tile-content class="align-end">{{ plantWeather.CurrentWeather.VisibilityKm | formatNumberTo2Decimals }} Km</v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile>
                                                <v-list-tile-content>Ozone:</v-list-tile-content>
                                                <v-list-tile-content class="align-end">{{ plantWeather.CurrentWeather.Ozone | formatNumberTo2Decimals }}</v-list-tile-content>
                                            </v-list-tile>
                                        </v-list>
                                    </v-card>
                                </v-flex>

                                <v-flex xl10 lg10 md8 sm6 xs12 pl-3>
                                    <h3 class="mb-3">7 Day Forecast</h3>
                                    <v-layout row wrap>
                                        <v-flex :xs12="$vuetify.breakpoint.smAndDown" :md4="$vuetify.breakpoint.mdOnly" :lg3="$vuetify.breakpoint.lgOnly" v-for="forecast in plantWeather.ForecastsWeather" v-bind:key="forecast.ForecastDate">
                                            <v-card>

                                                <v-layout>
                                                    <v-flex xs4>
                                                        <v-card-title class="subheading">{{ forecast.ForecastDate | formatDate }}</v-card-title>
                                                    </v-flex>
                                                    <v-flex xs8 class="text-xs-right" mr-2 mt-1>
                                                        <weatherIcon :WeatherIconName="forecast.Icon" :width="64" :height="64"></weatherIcon>
                                                    </v-flex>
                                                </v-layout>

                                                <v-divider></v-divider>

                                                <v-list dense>
                                                    <v-list-tile>
                                                        <v-list-tile-content style="max-width:180px; height:auto; padding-top:5px;">{{ forecast.Summary }}</v-list-tile-content>
                                                    </v-list-tile>
                                                    <v-list-tile>
                                                        <v-list-tile-content>Temperature Min:</v-list-tile-content>
                                                        <v-list-tile-content class="align-end">{{ forecast.TemperatureMin | formatNumberTo2Decimals }} &#8451;</v-list-tile-content>
                                                    </v-list-tile>
                                                    <v-list-tile>
                                                        <v-list-tile-content>Temperature Max:</v-list-tile-content>
                                                        <v-list-tile-content class="align-end">{{ forecast.TemperatureMax | formatNumberTo2Decimals }} &#8451;</v-list-tile-content>
                                                    </v-list-tile>

                                                    <v-list-tile>
                                                        <v-list-tile-content>Precip Probability:</v-list-tile-content>
                                                        <v-list-tile-content class="align-end">{{ forecast.PrecipProbability | formatDecimalToPercentage }}</v-list-tile-content>
                                                    </v-list-tile>
                                                    <v-list-tile>
                                                        <v-list-tile-content>Precip Intensity:</v-list-tile-content>
                                                        <v-list-tile-content class="align-end">{{ forecast.PrecipIntensityMmph | formatNumberTo2Decimals }} mm/h</v-list-tile-content>
                                                    </v-list-tile>
                                                    <v-list-tile>
                                                        <v-list-tile-content>Precip Type:</v-list-tile-content>
                                                        <v-list-tile-content class="align-end">{{ forecast.PrecipType }}</v-list-tile-content>
                                                    </v-list-tile>

                                                    <v-list-tile>
                                                        <v-list-tile-content>Humidity:</v-list-tile-content>
                                                        <v-list-tile-content class="align-end">{{ forecast.Humidity | formatDecimalToPercentage }}</v-list-tile-content>
                                                    </v-list-tile>
                                                    <v-list-tile>
                                                        <v-list-tile-content>Pressure:</v-list-tile-content>
                                                        <v-list-tile-content class="align-end">{{ forecast.PressureHectopascals | formatNumberTo2Decimals }}</v-list-tile-content>
                                                    </v-list-tile>
                                                    <v-list-tile>
                                                        <v-list-tile-content>Wind Speed:</v-list-tile-content>
                                                        <v-list-tile-content class="align-end">{{ forecast.WindSpeedKmph | formatNumberTo2Decimals }} Km/h</v-list-tile-content>
                                                    </v-list-tile>
                                                    <v-list-tile>
                                                        <v-list-tile-content>Wind Bearing:</v-list-tile-content>
                                                        <v-list-tile-content class="align-end">{{ forecast.WindBearingDegrees | formatNumberTo2Decimals }} &#176;</v-list-tile-content>
                                                    </v-list-tile>
                                                    <v-list-tile>
                                                        <v-list-tile-content>Cloud Cover:</v-list-tile-content>
                                                        <v-list-tile-content class="align-end">{{ forecast.CloudCover | formatDecimalToPercentage }}</v-list-tile-content>
                                                    </v-list-tile>
                                                    <v-list-tile>
                                                        <v-list-tile-content>UV Index:</v-list-tile-content>
                                                        <v-list-tile-content class="align-end">{{ forecast.UVIndex | formatNumberTo2Decimals }}</v-list-tile-content>
                                                    </v-list-tile>
                                                </v-list>
                                            </v-card>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-card>
    </v-flex>
</v-layout>
</template>

<script>
import weatherApi from '../../api/weatherApi';
import weatherIcon from '../../components/generic/weatherIcon';

export default {
    components: {
        weatherIcon
    },
    data() {
        return {
            WeatherData: null
        };
    },
    async mounted() {
        this.WeatherData = await weatherApi.getWeatherDataForAllPlants();
    }
}
</script>

<style>

</style>
